import LanguageFlag from "../../company/components/language-flag";

const LanguageSwitch = ({ value, options = [], onChange, isDisabled }) => {
  if (options.length <= 1) return null;

  return (
    <div className="fixed top-5 right-5 z-50 flex gap-1 rounded-full bg-white p-1.5 shadow-custom-sm">
      {options.map((language) => (
        <button
          key={language}
          type="button"
          onClick={() => onChange(language)}
          disabled={isDisabled}
          className={`w-9 h-9 inline-flex items-center justify-center rounded-full transition disabled:cursor-not-allowed ${language === value ? "bg-[#eef3f8]" : "opacity-40 enabled:hover:opacity-100"}`}
        >
          <LanguageFlag language={language} />
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
